export default __webpack_public_path__ + "img/6943e5a5843e87376644c14259a7947d.svg";